import {
  Utensils, Pizza, Fish, Beef, Salad, Beer, Coffee, IceCream, Cake, CupSoda, Sandwich, Drumstick, Soup,
  ShoppingBag, Shirt, Watch, Glasses, SprayCan, Smartphone, Sofa, BookOpen, Gamepad2, Baby, Footprints, Gem,
  Scissors, Sparkles, Hand, Bath, Syringe, Sun, Palette,
  HeartPulse, Stethoscope, Pill, Eye, Brain, Activity, Apple,
  Dumbbell, Waves, Bike, Film, Trophy, Wine, Dices, Music, Languages, Car, GraduationCap,
  ShoppingCart, Wheat, Sprout, PawPrint, Dog,
  Wrench, Droplets, Truck, Flower2, Plug, Brush, KeyRound,
  Cpu, Laptop, HardDrive, Signal,
  Plane, Hotel, Umbrella, Home,
  Tag, Store,
} from "lucide-react";

// category id -> lucide icon
const MAP = {
  // food
  food: Utensils, sushi: Fish, pizza: Pizza, hamburger: Sandwich, "ristorante-tradizionale": Utensils,
  "ristorante-etnico": Soup, "pesce-crudo": Fish, steakhouse: Beef, "vegetariano-vegano": Salad,
  aperitivo: Wine, "pub-birreria": Beer, "colazione-bar": Coffee, "dolci-gelati": IceCream,
  pasticceria: Cake, "poke-asporto": Salad, "kebab-street": Drumstick,
  // shopping
  shopping: ShoppingBag, "abbigliamento-uomo": Shirt, "abbigliamento-donna": Shirt, "abbigliamento-bambino": Baby,
  "scarpe-accessori": Footprints, "abbigliamento-sportivo": Footprints, "gioielleria-orologi": Watch,
  "occhiali-ottica": Glasses, profumeria: SprayCan, "elettronica-gadget": Smartphone, "articoli-casa": Sofa,
  "libreria-cartoleria": BookOpen, giocattoli: Gamepad2,
  // bellezza
  bellezza: Scissors, "parrucchiere-barbiere": Scissors, "centro-estetico": Sparkles, "unghie-manicure": Hand,
  "massaggi-spa": Bath, tatuaggi: Syringe, solarium: Sun, depilazione: Sparkles, "profumeria-cosmetici": Palette,
  // salute
  salute: HeartPulse, dentista: Activity, "farmacia-parafarmacia": Pill, "ottico-optometrista": Eye,
  fisioterapia: Activity, nutrizionista: Apple, "studio-medico": Stethoscope, psicologo: Brain,
  // sport
  sport: Dumbbell, "palestra-corsi": Dumbbell, "piscina-nuoto": Waves, "padel-tennis": Trophy, calcetto: Trophy,
  "yoga-pilates": Activity, "arti-marziali": Trophy, "cinema-teatro": Film, "bowling-svago": Dices,
  "sale-giochi": Gamepad2, "esperienze-cantine": Wine, "noleggio-bici": Bike,
  // spesa
  spesa: ShoppingCart, supermercato: ShoppingCart, "macelleria-pescheria": Beef, fruttivendolo: Apple,
  panificio: Wheat, gastronomia: Soup, enoteca: Wine, biologico: Sprout, "prodotti-animali": PawPrint,
  // servizi
  servizi: Wrench, "lavaggio-auto": Droplets, "meccanico-gomme": Wrench, carrozzeria: Car, "noleggio-auto": KeyRound,
  lavanderia: Droplets, fiorista: Flower2, "idraulico-elettricista": Plug, pulizie: Brush, traslochi: Truck,
  // tech
  tech: Cpu, "riparazione-telefoni": Smartphone, "riparazione-pc": Laptop, "informatica-negozio": HardDrive, telefonia: Signal,
  // viaggi
  viaggi: Hotel, "hotel-bb": Hotel, agriturismo: Home, "stabilimento-balneare": Umbrella, "agenzia-viaggi": Plane,
  // famiglia
  famiglia: Baby, ludoteca: Gamepad2, "asilo-doposcuola": Baby, "articoli-neonati": Baby,
  // formazione
  formazione: GraduationCap, lingue: Languages, musica: Music, "scuola-guida": Car, ripetizioni: BookOpen,
  // animali
  animali: PawPrint, toelettatura: Dog, veterinario: Stethoscope, "pet-shop": PawPrint,
  // altro
  altro: Store,
};

export function CatIcon({ id, className = "h-4 w-4" }) {
  const Ico = MAP[id] || Tag;
  return <Ico className={className} />;
}

export function catIconFor(id) {
  return MAP[id] || Tag;
}
